import { Pipe, PipeTransform } from '@angular/core';
import { Language } from '@app/shared/enums/language-enum';
import { COUNTRIES, LANGUAGES } from '@app/shared/pipes/urls-pipes/urls.conts';
import { CookiesRules } from './cookies_policy.urls';

@Pipe({
  name: 'cookiesPolicyPipe',
  standalone: true,
})
export class CookiesPolicyPipe implements PipeTransform {
  transform(lang: string): string {
    const URL = window.location.href;
    const country = COUNTRIES.find((v) => URL.toLowerCase().includes(v)) || 'belgium';
    const language = LANGUAGES.includes(lang as Language) ? lang : 'en';
    return CookiesRules[country][language];
  }
}
